<script>
  import IconAlert from '@/assets/svg/icon-alert.svg?inline';
  import IconAnonymous from '@/assets/svg/icon-anonymous.svg?inline';
  import IconArchive from '@/assets/svg/icon-archive.svg?inline';
  import IconReopen from '@/assets/svg/icon-reopen.svg?inline';
  import IconBoy from '@/assets/svg/icon-boy.svg?inline';
  import IconCalendar from '@/assets/svg/icon-calendar.svg?inline';
  import IconCantonZH from '@/assets/svg/icon-canton-zh.svg?inline';
  import IconCheckmark from '@/assets/svg/icon-checkmark.svg?inline';
  import IconChevronDown from '@/assets/svg/icon-chevron-down.svg?inline';
  import IconChevronLeft from '@/assets/svg/icon-chevron-left.svg?inline';
  import IconChevronRight from '@/assets/svg/icon-chevron-right.svg?inline';
  import IconChevronUp from '@/assets/svg/icon-chevron-up.svg?inline';
  import IconDelete from '@/assets/svg/icon-delete.svg?inline';
  import IconDownload from '@/assets/svg/icon-download.svg?inline';
  import IconUpload from '@/assets/svg/icon-upload.svg?inline';
  import IconEdit from '@/assets/svg/icon-edit.svg?inline';
  import IconFieldsAll from '@/assets/svg/icon-fields-all.svg?inline';
  import IconFieldsSAV from '@/assets/svg/icon-fields-sav.svg?inline';
  import IconFinal from '@/assets/svg/icon-final.svg?inline';
  import IconFinalize from '@/assets/svg/icon-finalize.svg?inline';
  import IconGirl from '@/assets/svg/icon-girl.svg?inline';
  import IconInfo from '@/assets/svg/icon-info.svg?inline';
  import IconPasswordHide from '@/assets/svg/icon-password-hide.svg?inline';
  import IconPasswordShow from '@/assets/svg/icon-password-show.svg?inline';
  import IconProfile from '@/assets/svg/icon-profile.svg?inline';
  import IconRedo from '@/assets/svg/icon-redo.svg?inline';
  import IconRefresh from '@/assets/svg/icon-refresh.svg?inline';
  import IconReviewBack from '@/assets/svg/icon-review-back.svg?inline';
  import IconReview from '@/assets/svg/icon-review.svg?inline';
  import IconSearch from '@/assets/svg/icon-search.svg?inline';
  import IconSort from '@/assets/svg/icon-sort.svg?inline';
  import IconTransfer from '@/assets/svg/icon-transfer.svg?inline';
  import IconUndo from '@/assets/svg/icon-undo.svg?inline';
  import IconMenu from '@/assets/svg/icon-menu.svg?inline';
  import IconComment from '@/assets/svg/icon-comment.svg?inline';
  import IconClose from '@/assets/svg/icon-close.svg?inline';
  import IconVersions from '@/assets/svg/icon-versions.svg?inline';
  import IconPDF from '@/assets/svg/icon-pdf.svg?inline';
  import IconWord from '@/assets/svg/icon-word.svg?inline';
  import IconJSON from '@/assets/svg/icon-json.svg?inline';

  const AUTO = 'auto';

  export default {
    name: 'Icon',
    components: {
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
      name: {
        type: String,
        default: null,
      },
      width: {
        type: String,
        default: AUTO,
      },
      height: {
        type: String,
        default: AUTO,
      },
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {
        icons: {
          fieldsAll: IconFieldsAll,
          fieldsSAV: IconFieldsSAV,
          fieldsState: IconCantonZH,

          passwordShow: IconPasswordShow,
          passwordHide: IconPasswordHide,

          menu: IconMenu,
          sort: IconSort,
          info: IconInfo,
          alert: IconAlert,
          edit: IconEdit,
          delete: IconDelete,
          search: IconSearch,
          transfer: IconTransfer,
          download: IconDownload,
          upload: IconUpload,
          anonymous: IconAnonymous,
          archive: IconArchive,
          reopen: IconReopen,
          calendar: IconCalendar,
          profile: IconProfile,
          checkmark: IconCheckmark,
          close: IconClose,

          girl: IconGirl,
          boy: IconBoy,

          undo: IconUndo,
          redo: IconRedo,
          refresh: IconRefresh,
          versions: IconVersions,

          chevronDown: IconChevronDown,
          chevronLeft: IconChevronLeft,
          chevronRight: IconChevronRight,
          chevronUp: IconChevronUp,
          final: IconFinal,
          finalize: IconFinalize,

          review: IconReview,
          returnReview: IconReviewBack,

          comment: IconComment,

          pdf: IconPDF,
          word: IconWord,
          json: IconJSON,
        },
      };
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {},
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {
    },
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    // filters: {},
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    // validations: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    render(h) {
      const icon = this.icons[this.name];
      if (icon) {
        const width = this.width;
        const height = this.height;
        let options = null;
        if (width !== AUTO || height !== AUTO) {
          options = { style: { width, height } };
        }
        return h(icon, options);
      }
      return null;
    },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {},
  };
</script>
